import React from 'react';
import { Link } from 'react-router-dom';
import AppLogo from '../../components/AppLogo';
import SiteFooter from '../../components/SiteFooter';
import { LEGAL_SUPPORT_EMAIL, SUPPORT_PHONE, COMPANY_ADDRESS } from '../../lib/siteContact';
import './legal.css';

const formatSupportPhone = (phone) =>
  phone.replace(/(\d{2})(?=\d)/g, '$1 ').trim();

export const LegalContactBlock = () => (
  <div className="legal-page__contact">
    <p>
      <strong>Innovative Info Solutions Pvt Ltd</strong>
    </p>
    <p>{COMPANY_ADDRESS.replace(/^25/, '# 25')}</p>
    <p>
      Email:{' '}
      <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a>
    </p>
    <p>
      Phone:{' '}
      <a href={`tel:+91${SUPPORT_PHONE}`}>+91 {formatSupportPhone(SUPPORT_PHONE)}</a>
    </p>
  </div>
);

export const DisputeSettlementBlock = () => (
  <>
    <h2>Dispute Settlement &amp; Jurisdiction</h2>
    <ol>
      <li>
        In case of any dispute arising from this Policy / Agreement, the Parties shall amicably
        settle it by way of conciliation within <strong>20 days</strong>.
      </li>
      <li>
        In the event of Parties are unable to settle the matter, the dispute can be referred to the{' '}
        <strong>Courts at Bangalore</strong> and Courts at Bangalore shall have the sole and
        exclusive jurisdiction over all disputes which may arise from this Policy / Agreement.
      </li>
    </ol>
  </>
);

const LegalPageLayout = ({ title, version, effectiveDate, children }) => (
  <div className="legal-page">
    <header className="legal-page__header">
      <div className="legal-page__header-inner">
        <AppLogo to="/" variant="header" />
        <Link to="/" className="legal-page__back">
          ← Back to home
        </Link>
      </div>
    </header>
    <main className="legal-page__main">
      <article className="legal-page__article">
        <header className="legal-page__title-block">
          <h1>{title}</h1>
          <p className="legal-page__meta">
            <strong>{version}</strong>
          </p>
          <p className="legal-page__meta">
            <strong>Effective Date:</strong> {effectiveDate}
          </p>
        </header>
        {children}
      </article>
    </main>
    <SiteFooter />
  </div>
);

export default LegalPageLayout;
